// This is the replacement for `RxDBContext` from `src/rxdb/useRxDB.tsx`
import { createContext } from 'react';

import { defaultFeatureFlags } from '@/featureFlags/defaultFeatureFlags';

import { crumbleAction } from './bakery/actionBakery';
import { DataManager } from './DataManager';
import { Dispatch } from './Dispatch';
import { createGoalResolvers } from './GoalResolvers';
import { logError } from './logError';
import { State } from './State';

export const dummyDispatch: Dispatch = action => {
  // This should never happen as long as `dataManagerContext` is only consumed
  // from a child component of `DataManagerHandler`,
  // which in turn sets an `DataManager` with a proper `Dispatch`.
  const error = new Error(`Attempted to dispatch ${action.kind} outside of DataManagerHandler`);
  logError(`Dummy Dispatch`, error, crumbleAction(action));
  throw error;
};

export const initialState: State = {
  borerSelected: false,
  cleaned: false,
  currentTask: undefined,
  database: undefined,
  disabled: false,
  featureFlags: defaultFeatureFlags,
  goalResolvers: createGoalResolvers(),
  nextTask: undefined,
  online: false,
  replication: undefined,
  trackingEvents: [],
  whenIdle: undefined,
  legacy: true,
};
export const initialManager: DataManager = { state: initialState, dispatch: dummyDispatch };

export const dataManagerContext = createContext<DataManager>(initialManager);
dataManagerContext.displayName = 'Data Manager Context';
